var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.compInfo)?_c('div',[(_vm.compInfo && _vm.compInfo.type==1)?_c('FactoryView',{attrs:{"comp":_vm.compInfo}}):_vm._e(),(_vm.compInfo && _vm.compInfo.type==2)?_c('DesignView',{attrs:{"comp":_vm.compInfo}}):_vm._e(),(_vm.compInfo && _vm.compInfo.type==3)?_c('SaleView',{attrs:{"comp":_vm.compInfo}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }